module.exports = __webpack_public_path__ + "img/2f69f0d.jpg";